<app-matrix-card
  title="{{ 'cards.matrixInvestigation' | translate }}"
  periodLabel="{{ 'cards.lastDays' | translate: { days: 30 } }}"
  iconUrl="/icons/investigation.png"
  link="/case-investigation-tracker"
  [highlighted]="highlighted"
  aria-label="{{ 'cards.matrixInvestigation' | translate }}"
>
  <div class="flex min-h-0 max-h-[200px] flex-col">
    <matrix-generic-table
      [columns]="columns()"
      [data]="data()"
      [totalRecords]="totalRecords()"
      [rows]="rows()"
      [loading]="loading()"
      [scrollHeight]="scrollHeight"
      [lazy]="false"
      [searchEnabled]="false"
      [exportEnabled]="false"
      (queryChange)="onQueryChange($event)"
    />
  </div>

  <ng-template #employeeCell let-row="row">
    <span class="text-white underline underline-offset-2">{{ row.managedEmployee }}</span>
  </ng-template>
</app-matrix-card>

<ng-template #statusHeaderTpl let-col="col">
  <div class="flex items-center gap-1 sm:gap-[7px] whitespace-nowrap">
    <span>{{ col.header }}</span>
    <!-- TODO: The status icon will be displayed later -->
    <!-- <img src="/Status.svg" alt="" class="w-10 h-10 sm:w-[40px] sm:h-[40px] shrink-0" aria-hidden="true" /> -->
  </div>
</ng-template>

<ng-template #dateHeaderTpl let-col="col">
  <div class="flex flex-col items-start gap-0.5 sm:gap-[7px]">
    <p
      class="text-[11px] sm:text-[14px] leading-[16px] sm:leading-[20px] font-normal text-slate-50"
    >
      Last Update
    </p>
    <span class="text-[14px] sm:text-[18px] font-semibold leading-[18px] sm:leading-[22px]">{{
      col.header
    }}</span>
  </div>
</ng-template>

<ng-template #timeHeaderTpl let-col="col">
  <div class="flex flex-col items-start gap-0.5 sm:gap-[7px]">
    <p
      class="text-[11px] sm:text-[14px] leading-[16px] sm:leading-[20px] font-normal text-slate-50"
    >
      Last Update
    </p>
    <span class="text-[14px] sm:text-[18px] font-semibold leading-[18px] sm:leading-[22px]">{{
      col.header
    }}</span>
  </div>
</ng-template>
